<template>
	<div class="flex p-3xl flex-col gap-3xl bg-white">
		<div class="flex h-[32px] flex-col justify-between opacity-[0.2]">
			<div class="w-[118px] h-7xl rounded-medium bg-[#424242]" />
		</div>
		<div class="flex gap-xl">
			<div v-for="i in 4" :key="i" class="flex flex-col items-center gap-md">
				<div
					class="flex size-[80px] p-xxs justify-center items-center aspect-square rounded-7xl bg-gray-100"
				/>
				<div
					class="w-[55px] h-2xl rounded-medium bg-[#424242] opacity-[0.2]"
				></div>
			</div>
		</div>
	</div>
</template>
